import * as types from '../constants/actionTypes';
import {wrapCall} from '../utils/serviceUtils';
import {api} from '../utils/services';

export const fetchSavedCards = () => {
  return wrapCall(
    api.get(`/user/cards`),
    types.FETCH_PAYMENT_CARDS,
  );
};

export const deletePaymentCard = (id) => {
  return wrapCall(
    api.delete(`/user/cards/${id}`),
    types.DELETE_PAYMENT_CARD,
    {id},
  );
};
